import { createContext, useContext } from 'react'

import { FieldConfig } from '../DynamicForm/types'

interface ResourceBulkEditState {
  selectedFieldNames: string[]
  editableFields: FieldConfig[]
  formFields: FieldConfig[]
  isSaving: boolean
  saveError: string | null
  selectedCount: number
  totalCount: number
  loading: boolean
  isConfirmOpen: boolean
  pendingFieldCount: number
}

interface ResourceBulkEditActions {
  addField: (fieldName: string) => void
  removeField: (fieldName: string) => void
  save: (formData: Record<string, unknown>) => void
  confirmSave: () => void
  cancelConfirm: () => void
  close: () => void
  updateField: (fieldName: string, updates: Partial<FieldConfig>) => void
  clearError: () => void
}

export interface ResourceBulkEditContextValue {
  state: ResourceBulkEditState
  actions: ResourceBulkEditActions
}

export const ResourceBulkEditContext =
  createContext<ResourceBulkEditContextValue | null>(null)

export function useResourceBulkEdit(): ResourceBulkEditContextValue {
  const context = useContext(ResourceBulkEditContext)
  if (!context) {
    throw new Error(
      'useResourceBulkEdit must be used within ResourceBulkEdit.Root',
    )
  }
  return context
}
